import { render, staticRenderFns } from "./InterventionForm.vue?vue&type=template&id=3afff69e&scoped=true"
import script from "./InterventionForm.vue?vue&type=script&lang=js"
export * from "./InterventionForm.vue?vue&type=script&lang=js"
import style0 from "./InterventionForm.vue?vue&type=style&index=0&id=3afff69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afff69e",
  null
  
)

export default component.exports